// Utility to generate optimized Cloudinary URLs for images
// Usage: getCloudinaryUrl(publicId, width, height)

// Get Cloudinary cloud name from environment variables
export const CLOUDINARY_CLOUD_NAME = import.meta.env.VITE_CLOUDINARY_CLOUD_NAME || 'your_cloud_name';

export function getCloudinaryUrl(
  publicId: string,
  width: number,
  height: number
) {
  // If input is already a full URL, return as is
  if (!publicId || publicId.startsWith("http://") || publicId.startsWith("https://")) {
    return publicId;
  }
  return `https://res.cloudinary.com/${CLOUDINARY_CLOUD_NAME}/image/upload/w_${width},h_${height},c_fill,q_auto,f_auto/${publicId}`;
}
